export default __webpack_public_path__ + "static/media/life.5e06697d.svg";